<script>
    import logo from "../../assets/images/logo.svg";
    export let background = "bg-white";
</script>

<div class="page {background}">
    <nav>
        <img class="logo" src={logo} alt="logo" />
    </nav>

    <div class="container">
        <slot></slot>
    </div>

    <footer>
        <p>Made with 💛 by Collabwriting Team</p>
        <p>
            Copyrights &copy; {new Date().getFullYear()} Collabwriting
        </p>
    </footer>
</div>

<style>
    @import "../../main.css";

    .page {
        @apply flex h-full min-h-screen w-full min-w-full flex-col items-center;
    }

    nav {
        @apply flex w-full max-w-screen-xl flex-col items-center p-8 sm:items-baseline;
    }

    .logo {
        @apply max-h-8;
    }

    .container {
        @apply my-auto;
    }

    footer {
        @apply w-full bg-black p-8 text-center text-sm font-light text-white;
    }
</style>
